var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('navBar'),_c('div',{staticClass:"zhongbox"},[_c('router-view')],1),_c('footer-bar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }